import React, { Component } from 'react'
// import MainMicrosoftOfficeExcel2010 from './main_microsoft_office_excel_2010'
import { Helmet } from 'react-helmet'
import DictsInfo from '../../components/dicts_info.jsx'

// import { Link } from 'react-router-dom';
// import GambarPointer1 from './img/pointer1.png'

// function refreshPage(){
//     setTimeout(()=>{
//       window.location.reload(false);
//     }, 500);
   
//   }


export default class MengenalFungsiOperasiUntukStatistikPadaMicrosoftOfficeExcel2010FungsiCountIf extends Component {
  render() {
    return (
      <div>

      <Helmet>
        <title>Mengenal Fungsi Operasi Untuk Statistik Pada Microsoft Office Excel 2010</title>
        <meta name="description" content="belajar Microsoft Office Excel, tutorial Microsoft Office Excel, tutorial Microsoft Excel untuk pemula"/>
      </Helmet>
      
        <section className="colorlib-about">
          <div className="colorlib-narrow-content">
            <div className="row">

              {/* <div className="col-md-6 col-md-offset-3 col-md-pull-3 animate-box" data-animate-effect="fadeInBottom"> */}
              <div className="col-md-9 col-md-offset-0 col-md-pull-0" >

              {/* <br/>
              <br/> */}
                  
                  
                <h1 style={{fontSize: '1.5rem'}} className="colorlib-heading">Mengenal Fungsi Operasi Untuk Statistik Pada Microsoft Office Excel 2010</h1>

                <h2>Fungsi COUNTIF</h2>

                <p>Apa fungsi COUNTIF pada microsoft office excel 2010?</p>
                <p>Fungsi COUNTIF digunakan untuk menghitung jumlah sel dalam suatu range dalam kriteria tertentu.</p>
                <p>Penulisan fungsi COUNTIF adalah seperti berikut:</p>               
                <p><b>=COUNTIF(range;criteria)</b></p>
                <div className= "w3-container" > 
                <p>Penjelasan:</p>
                    <div className= "w3-container" > 
                        <ul> 
                            <li>
                            range
                                <br/>
                                adalah satu atau kumpulan beberapa sel yang akan dihitung jumlah selnya.
                            </li>                             
                            <li>
                            criteria
                                <br/>
                                Adalah syarat yang harus dimiliki akan dapat masuk hitungan.
                            </li>                             
                        </ul> 
                    </div>
                </div>

                <p>Contoh:</p>
                <div className= "w3-container" > 
                    <div className= "w3-container" > 
                      <p>Nilai dari sel:
                          <br/>
                          A1=Mobil, A2=Motor, A3=Mobil, A4=Perahu, A5=Sepeda.
                          <br/>
                          B1=20, B2=30, B3=40, B4=50, B5=60.
                      </p>                          
                          
                      <div className= "w3-container" > 
                        <ul>
                          <li>
                          Mencari jumlah sel dengan nama data di dalamnya <b>"mobil"</b>
                          <br/>
                          <b>=COUNTIF(A1:A5;"mobil")</b>
                          <br/>
                          maka hasil yang diperoleh adalah <b>2</b>. Karena ada dua sel dengan data di dalamnya <b>"mobil"</b>.
                          </li>
                          <br/>

                          <li>
                          Mencari jumlah sel yang data di dalamnya sama dengan data sel A4, yaitu <b>"Perahu"</b>.
                          <br/>
                          <b>=COUNTIF(A1:A5;A4)</b>
                          <br/>
                          maka hasil yang diperoleh adalah <b>1</b>. Karena hanya sel A4 yang memiliki data bernama <b>"Perahu"</b>.
                          </li>
                          <br/>

                          <li>
                          Mencari jumlah sel yang memiliki data sama dengan sel A2 yaitu <b>"Motor"</b> dan A3 yaitu <b>"Mobil"</b>.
                          <br/>
                          <b>=COUNTIF(A1:A5;A3)+COUNTIF(A1:A5;A2)</b>
                          <br/>
                          maka hasil yang diperoleh adalah <b>3</b>. Karena sel dengan nama <b>"Motor"</b> ada satu dan sel dengan nama <b>"Mobil"</b> ada dua.
                          </li>
                          <br/>

                          <li>
                          Mencari jumlah sel pada range B1:B5 yang memiliki nilai lebih besar dari 30.
                          <br/>
                          <b>=COUNTIF(B1:B5;"&gt;30")</b>
                          <br/>
                          maka hasil yang diperoleh adalah <b>3</b>.
                          </li>
                          <br/>

                          <li>
                          Mencari jumlah sel pada range B1:B5 yang memiliki besar nilai sama seperti nilai pada sel B4.
                          <br/>
                          <b>=COUNTIF(B1:B5;"="&B4)</b>
                          <br/>
                          maka hasil yang diperoleh adalah <b>1</b>. Karena hanya sel B4 yang memiliki nilai 50.
                          </li>
                          <br/>

                          <li>
                          Mencari nilai pada range B1:B5 yang memiliki nilai tidak sama seperti nilai pada sel B4.
                          <br/>
                          <b>=COUNTIF(B1:B5;"&lt;&gt;"&B4)</b>
                          <br/>
                          maka hasil yang diperoleh adalah <b>4</b>. Karena ada 4 sel yang memiliki nilai berbeda.
                          </li>

                        </ul> 
                      </div>
                    </div>
                </div>

               

                <br/>
                <p><b>Semoga Bermanfaat..</b></p>
               
              </div>
              <DictsInfo/>
            </div>

            {/* <div className="row row-pt-md"></div> */}

          </div>
        </section>
        {/* <MainMicrosoftOfficeExcel2010/> */}
      </div>
    )
  }
}
